import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

export default function QuestionExperienceWithPlantsPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-how-many-plants')
  }

  return (
    <main className="mx-auto flex h-dvh max-w-4xl flex-col overflow-y-auto px-8 pt-8 pb-14 md:max-w-full">
      <div className="mb-4 flex items-center justify-end">
        <Link
          className="custom-heading hover:opacity-80"
          to="/account/sign-in"
          data-testid="button-login"
        >
          {t('shared.signIn')}
        </Link>
      </div>
      <QuestionPage
        heading={t('pages.onboarding.questionExperienceWithPlants.heading')}
        buttons={[
          {
            text: t(
              'pages.onboarding.questionExperienceWithPlants.completeBeginner',
            ),
            value: 'complete_beginner',
          },
          {
            text: t('pages.onboarding.questionExperienceWithPlants.fewPlants'),
            value: 'few_plants',
          },
          {
            text: t(
              'pages.onboarding.questionExperienceWithPlants.experiencedParent',
            ),
            value: 'experienced_parent',
          },
          {
            text: t(
              'pages.onboarding.questionExperienceWithPlants.expertGardener',
            ),
            value: 'expert_gardener',
          },
        ]}
        onSubmit={handleSubmit}
      />
    </main>
  )
}
